import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

function DownloadAppSection() {
  const { t } = useTranslation();
  const [globalData, setGlobalData] = useState({});
  const myGlobalData = useSelector((state) => state.globalData);

  useEffect(() => {
    if (myGlobalData && myGlobalData?.data) {
      const settingsData = JSON.parse(myGlobalData?.data);
      setGlobalData(settingsData);
    }
  }, [myGlobalData]);

  const appStoreUrl = globalData?.app_store_url || "";
  const playStoreUrl = globalData?.play_store_url || "";

  const storeBtnClass =
    "inline-flex items-center gap-3 bg-white text-[var(--black-scale-900)] rounded-xl px-4 py-2.5 min-w-[170px] !no-underline hover:bg-primary-50 transition-colors";

  return (
    <section className="download-app-section bg-primary-400 m-[10px] lg:m-[15px] rounded-[20px] py-10 md:py-14 lg:py-20">
      <div className="container">
        <div className="max-w-xl">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white mb-3">
            {t("home.download_app_eyebrow")}
          </p>
          <h2 className="heading-web-h2 text-white mb-4">
            {t("home.download_app_heading")}
          </h2>
          <p className="text-white body-sm !text-base !leading-relaxed mb-8 max-w-lg opacity-90">
            {t("home.download_app_description")}
          </p>

          <div className="flex flex-wrap items-center gap-3">
            <a
              href={appStoreUrl}
              target={appStoreUrl !== "#" ? "_blank" : undefined}
              rel={appStoreUrl !== "#" ? "noopener noreferrer" : undefined}
              className={storeBtnClass}
              aria-label={t("home.download_on_app_store")}
            >
              <svg className="w-7 h-7 shrink-0" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47C4.25 16.98 2.93 12.44 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.9 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" />
              </svg>
              <span className="flex flex-col leading-tight text-left">
                <span className="text-[10px] uppercase tracking-wide opacity-70">Download on the</span>
                <span className="text-sm font-semibold">App Store</span>
              </span>
            </a>

            <a
              href={playStoreUrl}
              target={playStoreUrl !== "#" ? "_blank" : undefined}
              rel={playStoreUrl !== "#" ? "noopener noreferrer" : undefined}
              className={storeBtnClass}
              aria-label={t("home.get_it_on_google_play")}
            >
              <svg className="w-7 h-7 shrink-0" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="#EA4335" d="M3 20.5V3.5c0-.59.34-1.11.84-1.35L13.69 12 3.84 21.85C3.34 21.6 3 21.09 3 20.5z" />
                <path fill="#FBBC04" d="M16.81 15.12L6.05 21.34l8.49-8.49 2.27 2.27z" />
                <path fill="#4285F4" d="M20.16 10.81c.34.27.59.69.59 1.19s-.22.9-.57 1.18L17.89 14.5 15.39 12l2.5-2.5 2.27 1.31z" />
                <path fill="#34A853" d="M6.05 2.66l10.76 6.22-2.27 2.27L6.05 2.66z" />
              </svg>
              <span className="flex flex-col leading-tight text-left">
                <span className="text-[10px] uppercase tracking-wide opacity-70">Get it on</span>
                <span className="text-sm font-semibold">Google Play</span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DownloadAppSection;
